import { render } from "./MainAccountPage.vue?vue&type=template&id=5227a43a&ts=true"
import script from "./MainAccountPage.vue?vue&type=script&lang=ts"
export * from "./MainAccountPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__